
/**************************************************************************
 * File: actions.ts
 * Notes: Functions for user and UI actions.
 **************************************************************************/

const $ = Mindbreeze['require']('jquery'); //initialize jquery library


export default {

  /************************************************
   * Name: closeWelcomeModal
   * Note: Close the welcome modal
   ***********************************************/
  closeWelcomeModal: function () {
    var welcomeModal = $('#welcomeModal');

    welcomeModal.hide();
  }
};
